import React from 'react';
import DefaultLayout from '../../../layout/DefautlLayout';
import Header from '../../../components/header/Header';
import { Link } from 'react-router-dom';
import TreatmentIntroBanner from '../../../components/treatmentBanner/treatmentBanner';

const EndoliftPage = () => {
	const prices = [{ label: 'Treatment', value: '€2000/£1360' }];

	return (
		<DefaultLayout>
			<Header />
			<div id="Content">
				<div className="content_wrapper clearfix">
					<div className="sections_group">
						<div className="extra_content">
							<TreatmentIntroBanner
								title="Endolift"
								description="Endolift is a minimally invasive laser treatment that targets fat and loose skin, stimulating collagen to lift and firm the face, neck, and body with minimal downtime."
								quote=" Precision lifting with minimal downtime. "
								backgroundImage="/assets/images/banners/treatment-xl-2.png"
							/>

							<div className="section mcb-section" id="image" style={{ paddingBottom: '70px' }}>
								<div className="section_wrapper mcb-section-inner">
									<div className="wrap mcb-wrap one valign-top clearfix">
										<div className="mcb-wrap-inner">
											<div className="column mcb-column one-third column_image">
												<div className="image_frame image_item scale-with-grid aligncenter has_border hrmargin_b_30">
													<div className="image_wrapper">
														<div className="mask"></div>
														<img
															className="scale-with-grid"
															src="/assets/images/treatments/endolift.jpg"
															alt="Endolift Procedure"
															width="960"
															height="960"
														/>
													</div>
												</div>
											</div>

											<div className="column mcb-column two-third column_column">
												<div className="column_attr clearfix">
													<h4>How It Works</h4>
													<p>
														A laser-powered micro-optical fiber is inserted beneath the skin under local anesthesia. The laser
														energy stimulates collagen production, tightens deep skin layers, and melts small fat pockets.
													</p>

													<h4>What to Expect</h4>
													<ul>
														<li>In-office procedure takes 15-60 minutes.</li>
														<li>Immediate visible lift, with full collagen benefits over 3-6 months.</li>
														<li>Usually only one session; touch-up possible after 6-12 months.</li>
														<li>Quick recovery—most resume normal activity within a few days.</li>
													</ul>

													<h4>Benefits</h4>
													<ul>
														<li>Non-surgical alternative to facelifts or liposuction.</li>
														<li>Tightens skin and reduces small fat deposits in face, chin, neck, arms, abdomen, thighs, knees.</li>
														<li>Long-lasting results—maintenance with proper skincare.</li>
													</ul>

													<h4>Possible Side Effects</h4>
													<ul>
														<li>Mild swelling, redness, bruising that subsides within days.</li>
														<li>Temporary discomfort at insertion points.</li>
														<li>Rare nerve irritation or numbness lasting weeks-months.</li>
													</ul>
												</div>
											</div>

											<div className="column mcb-column one column_column">
												<div className="column_attr clearfix">
													<div className="column one column_pricing_item">
														<div className="pricing-box custom-pricing-box pricing-box-table pricing-box-featured">
															<div className="plan-header">
																<h3>Pricing</h3>
															</div>
															<div className="plan-inside clearfix">
																<hr className="bg-theme" />
																<ul>
																	{prices.map(({ label, value }, idx) => (
																		<li key={idx} className="clearfix" style={{ paddingLeft: '5%', paddingRight: '5%' }}>
																			<div>
																				<strong>{label}</strong>
																			</div>
																			<div>{value}</div>
																		</li>
																	))}
																</ul>
																<hr className="bg-theme" />
															</div>

															<div className="plan-footer">
																<Link to="/book-now" className="button button_left button_theme button_js">
																	<span className="button_icon">
																		<i className="icon-basket"></i>
																	</span>
																	<span className="button_label">BOOK NOW</span>
																</Link>
															</div>
														</div>
													</div>
												</div>
											</div>

											<div className="column mcb-column one column_divider">
												<hr className="no_line" />
											</div>

											<div className="column one column_slider">
												<div className="column_attr clearfix hrmargin_b_60">
													<h2 className="hrmargin_b_60" style={{ textAlign: 'center' }}>
														Results
													</h2>
													<div className="content_slider">
														<ul className="content_slider_ul">
															<li className="content_slider_li_1">
																<img
																	width="100%"
																	height="auto"
																	src="/assets/images/treatments/endolift-result.jpg"
																	alt="Endolift results"
																	className="scale-with-grid wp-post-image"
																/>
															</li>
														</ul>
													</div>
												</div>
											</div>

											<div className="column mcb-column one column_divider">
												<hr className="no_line" />
											</div>

											<div className="column mcb-column one column_column">
												<div className="column_attr clearfix">
													<h2 className="hrmargin_b_60" style={{ textAlign: 'center' }}>
														After-Care
													</h2>
													<ul>
														<li>
															Avoid strenuous activity, saunas, hot baths, and pools for 2–3 days to support healing and minimise
															swelling.
														</li>
														<li>
															Apply ice and light massage as advised by your practitioner to reduce swelling and improve comfort.
														</li>
														<li>
															Use gentle skincare; avoid strong actives like retinoids or exfoliants for several days to protect
															the skin barrier.
														</li>
														<li>
															Monitor and report any excessive swelling, numbness, or discomfort promptly to your provider for
															follow-up care.
														</li>
													</ul>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</DefaultLayout>
	);
};

export default EndoliftPage;
